// extracted by css-extract-rspack-plugin
export default {"acquisitionBannerRichText":"c7nUVIOlGMSICkZk","acquisitionBannerRichTextLink":"rkOfxYL7REgHNQQz"};